<template>
  <div
    class="offcanvas offcanvas-end border-0 visible shadow"
    :class="show ? 'show' : ''"
    tabindex="-1"
    id="theme-settings-offcanvas"
    aria-modal="true"
    role="dialog"
    style="right: 1 !important; width: 550px"
  >
    <div
      class="d-flex align-items-center p-4 border-bottom border-bottom-dashed gap-2"
    >
      <div class="avatar-xs flex-shrink-0 me-2">
        <span class="avatar-title bg-light text-dark border rounded fs-3">
          <i :class="props.icon"></i>
        </span>
      </div>
      <h4 class="flex-grow-1 mb-0 me-2">{{ title }}</h4>
      <div>
        <button
          type="button"
          class="btn btn-default btn-icon btn-sm fs-16 close-btn-overview"
          @click="closeDetail()"
        >
          <i class="ri-close-fill align-bottom"></i>
        </button>
      </div>
    </div>
    <div class="offcanvas-body pt-1">
      <slot></slot>
    </div>
    <div class="offcanvas-footer border-top p-3 text-center">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
// Tidak perlu export default di <script setup>
// Ganti dengan defineOptions jika ingin memberi nama komponen
defineOptions({
  name: "Offcanvas",
});

const emit = defineEmits(["close"]);
import { ref } from "vue";
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Offcanvas Title",
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  icon: {
    type: String,
    default: "ri-information-line",
  },
});

const closeDetail = () => {
  // Emit event to close the offcanvas
  emit("close");
};
</script>

<style scoped></style>
